import dayjs from 'dayjs';

export function formatDateRange(dateStart, dateEnd, formats) {
    formats = typeof formats === 'object' ? formats : {};
    Object.assign(formats, {
        full: 'MMM D, YYYY',
        start: 'MMM D',
        end: 'D, YYYY',
        endMonth: 'MMM ',
        dash: ' - ',
    });

    // adapted from
    // https://gist.github.com/jb510/23dc81a2228296322811#file-pretty-php-date-ranges-php

    if (dateStart !== null) {
        dateStart = dayjs.isDayjs(dateStart) ? dateStart : dayjs(dateStart);
    }
    if (dateEnd !== null) {
        dateEnd = dayjs.isDayjs(dateEnd) ? dateEnd : dayjs(dateEnd);
    }
    if (dateStart === null || dateEnd === null || dateStart.isSame(dateEnd, 'day') ) {
        return (dateStart || dateEnd).format(formats.full);
    }
    if (dateStart.isSame(dateEnd, 'month')) {
        return dateStart.format(formats.start) + formats.dash + dateEnd.format(formats.end);
    }
    if (dateStart.isSame(dateEnd, 'year')) {
        return dateStart.format(formats.start) + formats.dash + dateEnd.format(formats.full);
    }
    return dateStart.format(formats.full) + formats.dash + dateEnd.format(formats.full)
}

